import { render, staticRenderFns } from "./zzldb.vue?vue&type=template&id=31f325f5&scoped=true"
import script from "./zzldb.vue?vue&type=script&lang=js"
export * from "./zzldb.vue?vue&type=script&lang=js"
import style0 from "./zzldb.vue?vue&type=style&index=0&id=31f325f5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f325f5",
  null
  
)

export default component.exports